(() => {
  angular.module('pims').directive('renderTab', ["$compile", $compile => {
    'ngInject';

    return {
      restrict: 'E',
      scope: {
        parent: '=',
        patient: '=',
        tab: '=',
        visit: '=',
        isActiveTab: '=',
      },

      link(scope, element) {
        const html = `<visit-${scope.tab} parent="parent" patient="patient" visit="visit" active="isActiveTab"></visit-${scope.tab}>`;
        element.replaceWith($compile(html)(scope));
      },
    };
  }]);
})();
